
<template>
  <div class="d-flex line">

    <a v-bind:href="'https://'+ link" target="_blank">
      <div :class="accountData.distance ? 'logo-wrapper d-flex align-items-end' : 'logo-wrapper-no-pin d-flex align-items-end'" :style="'background-color:'+(headerColour ? headerColour:  '#FFFFFF')">
        <img class="shopLogo" v-bind:src="logoUrl" />
      </div>
    </a>


    <div class="cardTexts">
      <div class="d-flex" v-if="accountData.distance">
        <img class="locationPin" src="../assets/location_pin.svg" alt="Distance pin">
        <p class="milesAway">{{accountData.distance.toFixed(2)}} miles away</p>
      </div>
      <a v-bind:href="'https://'+ link" target="_blank" class="accountNameLink">
        <h3>{{accountData.name}}</h3>
      </a>
      <p class="shopDescription" ref="shopDescription" >{{pageText ? pageText : 'Take a look at the webshop to check out what\'s on offer.'}}</p>
      <div class="webshopLink mb-0 pb-0 pb-md-2 mb-md-4">
        <a v-bind:href="'https://'+ link" target="_blank">
          <span class="buyAGift">Buy a gift &nbsp; &nbsp;</span>
          <span :style="{marginLeft:'8px',position:'relative',top:'-1px'}">
            <img :style="{height:'9px'}" src='../assets/arrow_right.svg'>
          </span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Card",
  props: {
    accountData: Object
  },
  computed: {

    /**
     * Gets the webstore page background colour element style
     * returns a default toggle blue colour for accounts with no logo
     */
    headerColour()
    {
      if (this.accountData.Image) {
        if(this.accountData.ThemeElementStyles){
          let element =  this.accountData.ThemeElementStyles.filter(tes => (tes.theme_element_id == 5 && tes.property == 'background-color'));
          if(element.length){
            return element[0].value;
          }
        }
        return false;
      } else {
        return '#7EB5F5';
      }
    },

    /**
     * checks if the account has a logo, and returns fallback image if not
     * gets the url for the logo sent down from the parent in the prop 'accountData'
     */
    logoUrl() {
      return this.accountData.Image ? this.accountData.Image.url : require('../assets/fall_back_logo.svg');
    },

    /**
     * gets the link for the shop sent down from the parent in the prop 'accountData', append campaign details
     */
    link() {
      return this.accountData.domain+'?utm_source=get_together_shop&utm_medium=website&utm_campaign=get_together_2022';
    },

    /**
     * gets the introduction paragraph associated with that account sent down from the parent in the prop 'accountData'
     */
    pageText() {
      if (!this.accountData.page_text) return "";
      if (this.accountData.page_text.length > 108)
        return this.accountData.page_text.substring(0, 108) + "...";
      return this.accountData.page_text;
    }
  },
  mounted() {}
};
</script>

<style>
@font-face {
  font-family: 'Manrope';
  src: url('../assets/fonts/Manrope.ttf') format('truetype');
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: 'Manrope-ExtraBold';
  src: url('../assets/fonts/Manrope-ExtraBold.ttf') format('truetype');
  font-style: normal;
}

.buyAGift {
  font-family: 'Manrope-ExtraBold';
}

a {
  font-family: 'Manrope';
  font-size: 0.9em;
}

h3{
  font-family: 'Manrope-ExtraBold';
  font-weight: 800 !important;
  font-size: 1.1rem !important;
  color: #042750;
  margin-bottom:0px !important;
} 

.container {
  padding: 20px;
}

.shopLogo {
  width: auto;
  max-height: 50px;
  max-width: 130px;
  position: absolute;
  top: -9999px;
  bottom: -9999px;
  left: -9999px;
  right: -9999px;
  margin: auto;
}

.shopImage {
  min-height: 150px;
}

div.trim {
  max-width: 300px;
  max-height: 200px;
  overflow: hidden;
}

.shopDescription {
  font-family: 'Manrope';
  text-align: left;
  color: #6E7F95;
  overflow: hidden;
  padding: 6px 0px 5px 0px;
  font-size: 12px;
  letter-spacing: 0px;
  text-overflow: ellipsis;
  margin: 0;
  min-height: 77px;
}

.milesAway{
  font-family: 'Manrope';
  font-size: 12px;
  color: #6E7F95;
  font-weight: 400;
  margin-bottom: 13px;
}

.cardTexts {
  margin: 51px 0 14px 0;
  padding: 0px 10px 0px 10px;
  max-height: 186px;
}

.line {
  border-bottom: 1px solid #E2E2E2;
}

.locationPin {
  height: 15px;
  margin: 1px 7px 0 0;
}

.webshopLink {
  text-align: left;
  font-weight: 600;
}

.webshopLink a {
  font-size: 14px;
  color: #042750;
}

.logo-wrapper {
  position: relative;
  height: 150px;
  margin: 51px 15px 0 0;
  border-radius: 20px;
  min-width: 250px;
  box-shadow: 0px 0px 20px #00000014;
}
.logo-wrapper-no-pin {
  position: relative;
  height: 150px;
  margin: 35px 15px 0 0;
  border-radius: 20px;
  min-width: 250px;
  box-shadow: 0px 0px 20px #00000014;
}
.logo-wrapper a{
  text-align: center;
  width: 100%;
  padding: 0px 0 50px 0;
}

.logo-wrapper-no-pin a {
  text-align: center;
  width: 100%;
  padding: 0px 0 50px 0;
}
.accountNameLink {
  cursor: pointer;
}

@media (max-width: 1120px) {
  .cardTexts {
    margin: 20px 0 16px 0;
  }

  .logo-wrapper {
    min-width: 120px;
    height: 80px;
    margin-top: 35px;
    border-radius: 10px;
  }
  .logo-wrapper a {
    padding: 0px 0 25px 0;
  }
  .logo-wrapper-no-pin {
    min-width: 120px;
    height: 80px;
    margin-top: 25px;
    border-radius: 10px;
  }
  .logo-wrapper-no-pin a {
    padding: 0px 0 25px 0;
  }
  .shopLogo {
    max-height: 26px;
    max-width: 90px;
  }
  h3 {
    font-size: .9rem !important;
  }
  .buyAGift {
    font-size: .7rem !important;
  }
  .shopDescription {
    font-size: 10px;
    min-height: 50px;
  }
  .milesAway {
    font-size: 10px;
    margin-bottom: 6px;
  }
  .locationPin {
    height: 8px;
    margin: 3px 7px 0 0;
  }
}
</style>